/* eslint-disable no-param-reassign */
const API_BASE = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : 'https://harbourmaster.nymtech.net';

export interface PagedResult<T> {
  page: number;
  size: number;
  total: number;
  items: T[];
}

export interface ServiceWithDates {
  service_provider_client_id: string;
  gateway_identity_key: string;
  ip_address: string;
  last_successful_ping_utc: Date;
  last_updated_utc: Date;
  routing_score: number;
}

const mapGatewayItem = (item: any) => {
  item.config_score_calculated = 0;

  if (item.self_described?.ip_packet_router?.address) {
    item.config_score_calculated += 100;
  }
  if (item.self_described?.network_requester?.address) {
    item.config_score_calculated += 100;
  }
  if (Boolean(item.self_described?.network_requester?.uses_exit_policy) !== false) {
    item.config_score_calculated += 100;
  }

  item.probe_score_calculated = 0;

  if (item.last_probe_result?.outcome?.as_entry?.can_connect) {
    item.probe_score_calculated += 100;
  }
  if (item.last_probe_result?.outcome?.as_entry?.can_route) {
    item.probe_score_calculated += 100;
  }
  if (item.last_probe_result?.outcome?.as_exit?.can_connect) {
    item.probe_score_calculated += 100;
  }
  if (item.last_probe_result?.outcome?.as_exit?.can_route_ip_v4) {
    item.probe_score_calculated += 100;
  }
  if (item.last_probe_result?.outcome?.as_exit?.can_route_ip_v6) {
    item.probe_score_calculated += 100;
  }
  if (item.last_probe_result?.outcome?.as_exit?.can_route_ip_external_v4) {
    item.probe_score_calculated += 100;
  }
  if (item.last_probe_result?.outcome?.as_exit?.can_route_ip_external_v6) {
    item.probe_score_calculated += 100;
  }

  item.last_testrun_utc = new Date(item.last_testrun_utc);
  item.last_updated_utc = new Date(item.last_updated_utc);
};

export const api = {
  services: async (): Promise<PagedResult<ServiceWithDates>> => {
    const res = await fetch(`${API_BASE}/v1/services?size=100`);
    const page = await res.json();
    page.items.forEach((item: any) => {
      item.last_successful_ping_utc = new Date(item.last_successful_ping_utc);
      item.last_updated_utc = new Date(item.last_updated_utc);
    });
    return page;
  },
  gateways: async (): Promise<PagedResult<any>> => {
    const res = await fetch(`${API_BASE}/v2/gateways?size=200`);
    const page = await res.json();
    page.items.forEach(mapGatewayItem);
    return page;
  },
  gateway: async (identityKey: string): Promise<any> => {
    const res = await fetch(`${API_BASE}/v2/gateways/${identityKey}`);
    const data = await res.json();
    mapGatewayItem(data);
    return data;
  },
};
